import { Pipe, PipeTransform } from '@angular/core';
import { VirtualTagsService } from '@shared/services/virtual-tags.service';

@Pipe({
    name: 'tagQueryParams'
})
export class TagQueryParamsPipe implements PipeTransform {
    constructor(private tagsService: VirtualTagsService) {
    }

    transform(id: any): any {
        return this.tagsService.tagQueryParams(id as number);
    }
}
